import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import {
  employeeJobLevel,
  jobRoleHasAssignableLevels,
} from 'modules/job_catalog/store/collections/levels'
import { jobLevelRole } from 'modules/job_catalog/store/collections/roles'

interface ReturnType {
  employees: Employee[]
}

const useEmployeesWithoutJobLevel = (
  employees: Employee[],
  contractVersions: ContractVersions
): ReturnType => {
  const employeesWithoutJobLevel = employees.reduce<Employee[]>((acc, employee) => {
    if (!employeeJobLevel(contractVersions, employee)) {
      acc.push(employee)
      return acc
    }

    const level = employeeJobLevel(contractVersions, employee)
    const role = level ? jobLevelRole(level) : null

    if (level?.isDefault && role && jobRoleHasAssignableLevels(role)) {
      acc.push(employee)
      return acc
    }
    return acc
  }, [])
  return { employees: employeesWithoutJobLevel }
}
export default useEmployeesWithoutJobLevel
